module.exports = __webpack_public_path__ + "static/media/TL-Horizontal-Black.20edfec6.svg";